<button
    type="button"
    class="ziti-status"
    [class.is-open]="metricsOpen"
    [attr.aria-pressed]="metricsOpen"
    [matTooltip]="tooltip"
    matTooltipPosition="right"
    (click)="toggleMetricsPanel()"
    id="ZitiStatusIndicator">
    <span class="ziti-status__caption">Secure connection</span>
    <span class="nf-badge ziti-status__badge" [ngClass]="badgeTone">
        <span class="nf-badge-dot"></span>
        {{ statusLabel }}
    </span>
    <svg class="ziti-status__chevron" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M6 3.5 10.5 8 6 12.5" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</button>
